import { defineMessages } from 'react-intl';

export default defineMessages({
    next: {
        id: 'fnol.adac.wizard.Next',
        defaultMessage: 'Next',
    },
    previous: {
        id: 'fnol.adac.wizard.Previous',
        defaultMessage: 'Previous',
    },
    goBackWarning: {
        id: 'fnol.adac.wizard.modal.Warning',
        defaultMessage: 'Warning'
    },
    goBackMessage: {
        id: 'fnol.adac.wizard.modal.Go back message',
        defaultMessage: 'Going to the first step will remove all of the previously provided information. Do you want to start the process from the beginning?'
    },
    wizardTitle: {
        id: 'fnol.adac.wizard.title.Claim Information',
        defaultMessage: 'Claim Information'
    },
    firstStepTitle: {
        id: 'fnol.adac.wizard.steps.Type of claim',
        defaultMessage: 'Type of claim'
    },
    secondStepTitle: {
        id: 'fnol.adac.wizard.steps.Patient and contact person',
        defaultMessage: 'Patient and contact person'
    },
    thirdStepTitle: {
        id: 'fnol.adac.wizard.steps.Loss cause',
        defaultMessage: 'Loss cause'
    },
    fourthStepTitle: {
        id: 'fnol.adac.wizard.steps.Call back',
        defaultMessage: 'Call back'
    },
    cancelButton: {
        id: 'fnol.adac.wizard.steps.Cancel',
        defaultMessage: 'Cancel'
    },
    yesButton: {
        id: 'fnol.adac.wizard.steps.Yes',
        defaultMessage: 'Yes'
    }
});
